import { Navigate } from 'react-router-dom';

import Pages from 'pages';

const routes = {
    Home: {
        title: 'common.navbar.home.title',
        path: '/home',
        component: <Pages.Home />,
        isOnMenu: true
    },
    AboutUs: {
        title: 'common.navbar.aboutUs.title',
        path: '/about-us',
        component: <Pages.AboutUs />,
        isOnMenu: true
    },
    Advantage: {
        title: 'common.navbar.advantage.title',
        path: '/advantage',
        component: <Pages.Advantage />,
        isOnMenu: true
    },
    ContactUs: {
        title: 'common.navbar.contactUs.title',
        path: '/contact-us',
        component: <Pages.ContactUs />,
        isOnMenu: true
    },
    PrivacyPolicy: {
        title: 'common.navbar.privacyPolicy.title',
        path: '/privacy-policy',
        component: <Pages.PrivacyPolicy />,
        isOnMenu: false
    },
    AmlPolicy: {
        title: 'common.navbar.amlPolicy.title',
        path: '/aml-policy',
        component: <Pages.AmlPolicy />,
        isOnMenu: false
    },
    AntiFraudPolicy: {
        title: 'common.navbar.antiFraudPolicy.title',
        path: '/antifraud-policy',
        component: <Pages.AntiFraudPolicy />,
        isOnMenu: false
    },
    Redirect: {
        path: '/',
        component: <Navigate to="/home" replace />
    }
};

export default routes;
